import React from 'react';
import Header from "../../../components/header/Header";
import Button from "../../../components/button/Button";

type Props = {};

function PlatformElements(props: Props) {

    return (
        <>
            <Header/>
            <div style={{padding:'100px'}}>
                <div>
                    Green Button Test
                    <Button
                        label={"Green Test"}
                        title={"Some Title"}
                        color={"green"}
                    />
                </div>
                <div>
                    Green Button Test - Outline
                    <Button
                        label={"Green Test"}
                        title={"Some Title"}
                        color={"green"}
                        outline={true}
                    />
                </div>
                <div>
                    Green Background Button Test
                    <Button
                        label={"Green Test"}
                        title={"Some Title"}
                        color={"greenbackground"}
                    />
                </div>
                <div>
                    Orange Button Test
                    <Button
                        label={"Orange Test"}
                        title={"Some Title"}
                        color={"orange"}
                    />
                </div>
                <div>
                    Orange Button Test - Outline
                    <Button
                        label={"Orange Test"}
                        title={"Some Title"}
                        color={"orange"}
                        outline={true}
                    />
                </div>
                <div>
                    Red Button Test
                    <Button
                        label={"Red Test"}
                        title={"Some Title"}
                        color={"red"}
                    />
                </div>
                <div>
                    Red Button Test - Outline
                    <Button
                        label={"Red Test"}
                        title={"Some Title"}
                        color={"red"}
                        outline={true}
                    />
                </div>
            </div>
        </>
    );
}

export default PlatformElements;
